"use client";
import { motion } from "framer-motion";
import {
  AppButton,
  Container,
  SectionSubHeading,
  SectionTitle,
} from "@/components";
import { serviceFaqs } from "@/data/ServiceEvidenceData";
import { cardRise, cardStagger, fadeInUp } from "@/lib/animation/variant";

const ServiceFaq = () => {
  return (
    <section className="w-full bg-background py-20 md:py-28">
      <Container className="flex flex-col gap-8 px-4 lg:px-10">
        <div className="space-y-2">
          <motion.div
            custom={0}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
          >
            <SectionSubHeading subtitle="Next step" />
          </motion.div>

          <motion.div
            custom={1}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
          >
            <SectionTitle title="Tell us the outcome." />
          </motion.div>
        </div>

        <motion.p
          custom={2}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
          className="max-w-2xl text-base leading-relaxed font-medium text-muted-foreground md:text-lg"
        >
          You do not need to know which service you need. Describe where the
          business is stuck and we will send back the shortest route to fixing
          it — including the parts you can skip and the parts you do not need us
          for.
        </motion.p>

        <motion.div
          custom={3}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
        >
          <AppButton href="/contact" buttonClass="h-14 px-10 font-black">
            Start a project
          </AppButton>
        </motion.div>

        <motion.dl
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.15 }}
          variants={cardStagger}
          className="mt-8 grid gap-5 md:grid-cols-2 xl:grid-cols-4"
        >
          {serviceFaqs.map((faq) => (
            <motion.div
              key={faq.title}
              variants={cardRise}
              className="rounded-2xl border border-black/10 p-6"
            >
              <dt className="mb-2.5 text-base font-black tracking-tight uppercase">
                {faq.title}
              </dt>
              <dd className="text-sm leading-relaxed text-muted-foreground">
                {faq.description}
              </dd>
            </motion.div>
          ))}
        </motion.dl>
      </Container>
    </section>
  );
};

export default ServiceFaq;
